import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthService } from './auth/services/auth.service';
import { HeaderService } from './common/services/header.service';
import { CommonService } from './common/services/common.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  /**
 * Variable which is used to define the url of the api from environment variable
 */
  apiUrlDb = environment.apiUrldb;
  /**
   * component constructor which is used to inject the required services.
   * @param dialogService To access the functions inside the DialogService.
   * @param authService To access the functions inside the AuthService.
   * @param headerService To access the functions inside the HeaderService.
   */
  constructor(
    private authService: AuthService,
    private headerService: HeaderService,
    private commonData: CommonService) { }
  /**
   * Component OnInit life cycle hook
   */
  ngOnInit() {
    this.authService.getMessages();
    this.commonData.getCountries();
    this.headerService.setHeaders(this.apiUrlDb + 'v1/login', 'content-type', 'application/json');
  }
}
